import React from 'react';
import styled from 'styled-components';
import { ValuePropData } from '../types/siteDataTypes';
import { Section, Container, SectionHeading } from '../styles/layout';

interface ValuePropProps {
  data?: ValuePropData;
}

const SectionTitle = styled(SectionHeading)`
  margin-bottom: 18px;

  p {
    margin: 0 0 10px;
    font-size: 17px;
    line-height: 1.7;
  }
`;

const Highlight = styled.div`
  background: linear-gradient(140deg, rgba(239, 244, 249, 0.6), rgba(223, 231, 240, 0.6));
  border: 1px solid #cfd9e4;
  border-radius: 16px;
  padding: 24px 26px;
  text-align: center;
  color: #4a5a6b;
  line-height: 1.75;
  box-shadow: 0 18px 36px rgba(34, 50, 70, 0.12);
`;

const ValueProp: React.FC<ValuePropProps> = ({ data }) => {
  return (
    <Section>
      <Container>
        <SectionTitle>
          <h2>{data?.heading || 'Loading...'}</h2>
          <p>{data?.body || ''}</p>
        </SectionTitle>
        {data?.supporting && <Highlight>{data.supporting}</Highlight>}
      </Container>
    </Section>
  );
};

export default ValueProp;
